import { css, Interpolation, Theme } from '@emotion/react'
import { avatarClasses, buttonClasses, touchRippleClasses } from '@mui/material'

export const container: Interpolation<Theme> = (theme) => css`
  min-height: 100%;
  width: 100%;
  padding: ${theme.spacing(3)};
`

export const header: Interpolation<Theme> = (theme) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: ${theme.spacing(2, 0, 3)};
`

export const title: Interpolation<Theme> = css`
  font-weight: 700;
`

export const exportButton: Interpolation<Theme> = css`
  padding-bottom: 12px;

  > [class*='MuiButton-startIcon'] {
    margin-right: 0;
    margin-bottom: 2px;
    svg {
      width: 20px !important;
      height: 20px !important;
    }
  }
`

export const filterInputs: Interpolation<Theme> = (theme) => css`
  flex: 1;
  display: flex;
  gap: ${theme.spacing(2)};
  flex-wrap: wrap;
`

export const search: Interpolation<Theme> = (theme) => css`
  width: 263px;

  ${theme.breakpoints.down(610)} {
    width: 100%;
  }
`

export const platformsSelect: Interpolation<Theme> = (theme) => css`
  width: 263px;

  ${theme.breakpoints.down(610)} {
    width: 100%;
  }
`

export const dateInput: Interpolation<Theme> = (theme) => css`
  width: 263px;

  ${theme.breakpoints.down(610)} {
    width: 100%;
  }

  .${touchRippleClasses.root} {
    display: none;
  }
`

export const dateRange: Interpolation<Theme> = (theme) => css`
  display: flex;
  gap: ${theme.spacing(2)};
  flex-wrap: wrap;

  ${theme.breakpoints.down(610)} {
    width: 100%;
  }
`

export const errorWrapper = (theme: Theme) => css`
  padding-top: ${theme.spacing(2)};
`

export const error = (theme: Theme) => css`
  color: ${theme.colors.red};
  font-weight: 600;
`

export const tableWrapper: Interpolation<Theme> = (theme) => css`
  margin-top: ${theme.spacing(3.75)};

  .table-header {
    min-height: 60px;

    .table-cell {
      display: flex;
      align-items: center;
      column-gap: ${theme.spacing(1.5)};

      .table-order-icon {
        position: static;
      }
    }
  }

  .table-cell {
    :nth-of-type(2) {
      overflow: hidden;
    }
  }

  .table-row {
    min-height: 84px;
    padding: ${theme.spacing(0.75, 1.5)};
  }

  .table-row .actions {
    box-sizing: border-box;
    height: 24px;
    display: flex;
    gap: 12px;
    align-items: end;
    transition: all ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut};
    overflow: hidden;
  }
  .table-row:not(:hover) .actions {
    height: 0;
  }
`

export const titleWrapper: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
`

export const fullNameCell: Interpolation<Theme> = (theme) => css`
  display: flex;
  align-items: center;
  column-gap: ${theme.spacing(1.5)};

  .${avatarClasses.root} {
    width: 28px;
    height: 28px;
  }
`

export const emailCell = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const membershipsCell: Interpolation<Theme> = (theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing(0.5)};
`

export const activeMembership: Interpolation<Theme> = (theme) => css`
  color: ${theme.colors.green};
`

export const pausedMembership: Interpolation<Theme> = (theme) => css`
  color: ${theme.colors.blue};
`

export const expiredMembership: Interpolation<Theme> = (theme) => css`
  color: ${theme.colors.typographyTwo};
`

export const headerWrapper: Interpolation<Theme> = css`
  justify-content: flex-end;
`

export const toolbarWrapper = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  column-gap: ${theme.spacing(2)};

  margin-top: ${theme.spacing(2)};
`

export const buttonGroup: Interpolation<Theme> = (theme) => css`
  flex-wrap: wrap;
  column-gap: ${theme.spacing(1.5)};

  .${buttonClasses.root} {
    border: none;
    min-width: 0;
  }
`

export const isBlockedFilterButton =
  (isActive: boolean): Interpolation<Theme> =>
  (theme) =>
    css`
      padding: 0;
      color: ${theme.colors.typographyThree};
      font-size: 16px;
      line-height: 20px;

      ${isActive &&
      css`
        color: ${theme.colors.typographyTwo};
      `}

      :hover {
        background-color: transparent;
        color: ${theme.colors.typographyThreeHover};
      }
    `

export const actions = (theme: Theme) => css`
  display: flex;
  column-gap: ${theme.spacing(1)};
`

export const action: Interpolation<Theme> = (theme: Theme) => css`
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid ${theme.colors.backgroundOne};
  border-radius: 10px;
  min-width: 0;

  &.MuiButtonBase-root:hover {
    background: none;
  }
`

export const bockButton = css`
  width: 98px;
`
